import React, { Component } from 'react';
import { NavLink, withRouter } from "react-router-dom";
import './NavBar.css';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Notifications from '../../components/Notifications/notifications';
import axios from 'axios';
import { APIURL, VERSION, VERSION_DATE } from '../../config';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import { Avatar, Box, ButtonBase, Dialog, DialogTitle, DialogContent, Divider, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import WhatsNew from '../WhatsNew/WhatsNew';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import BadgeIcon from '@mui/icons-material/Badge';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const BRAND = '#3FA7D6';
const BRAND_LIGHT = '#EBF8FF';
const TEXT = '#1f2d3d';
const MUTED = '#6b7a99';
const BORDER = '#e3e8ef';
const DEFAULT_LOGO = '/FieldworkerIcon.png';

// The Support button is portaled over the navbar by App.js (40px wide, fixed at right: SUPPORT_BUTTON_RIGHT).
// The right padding puts the bell directly to its right, so all icons stay equidistant.
const ICON_SIZE = 40;
export const SUPPORT_BUTTON_RIGHT = 56;
const TOOLBAR_RIGHT_PADDING = SUPPORT_BUTTON_RIGHT - ICON_SIZE;

const pillInputSx = {
    borderRadius: '24px',
    backgroundColor: '#f5f8fb',
    fontSize: 14,
    transition: 'background-color 150ms, box-shadow 150ms',
    '& fieldset': { borderColor: BORDER },
    '&:hover fieldset': { borderColor: BRAND },
    '&.Mui-focused': { backgroundColor: '#ffffff', boxShadow: '0 0 0 3px rgba(63, 167, 214, 0.15)' },
    '&.Mui-focused fieldset': { borderColor: BRAND, borderWidth: '1px' },
};

const actionIconSx = {
    color: MUTED,
    transition: 'color 150ms, background-color 150ms',
    '&:hover': { color: BRAND, backgroundColor: BRAND_LIGHT },
    '&.active': { color: BRAND, backgroundColor: BRAND_LIGHT },
};

const menuPaperProps = {
    elevation: 0,
    sx: {
        mt: 1,
        minWidth: 220,
        borderRadius: '10px',
        border: `1px solid ${BORDER}`,
        boxShadow: '0 8px 24px rgba(31, 45, 61, 0.12)',
        '& .MuiMenuItem-root': { fontSize: 14, py: 1, color: TEXT },
        '& .MuiListItemIcon-root': { color: MUTED, minWidth: 32 },
    },
};

const getInitials = (name) => {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
};


class NavBar extends Component {
    state = {
        anchorEl: null,
        anchorElCompany: null,
        newNotificationAlert: false,
        numberNotifRecorded: 0,
        whatsNewVersionsCount: 0,
        isDialogOpen: false,
        logoSrc: this.props.user.company_logo ? this.props.user.company_logo : DEFAULT_LOGO,
        searchQuery: '',
        searchResults: [],
        searchLoading: false,
        assignedPrograms: [],
    }

    _searchDebounce = null;
    _searchSeq = 0;
    _dataCache = null;
    _dataCacheCompId = null;

    // function handles the pop-up help window
    PopUpHelp() {
        window.open('https://fieldworker.gitbook.io/fieldworker-docs/', 'Data', 'height=700,width=1000');
    }
    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleOpenDialog = () => {
        this.setState({ isDialogOpen: true });
    };

    handleCloseDialog = () => {
        this.setState({ isDialogOpen: false });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleOpenCompanyMenu = (event) => {
        this.setState({ anchorElCompany: event.currentTarget });
    };

    handleCloseCompanyMenu = () => {
        this.setState({ anchorElCompany: null });
    };

    handleMenuNavigate = (path) => {
        this.setState({ anchorElCompany: null });
        this.props.history.push(path);
    };

    handleMenuAuth = () => {
        this.setState({ anchorElCompany: null });
        if (this.props.isAuth) {
            this.props.logout();
        } else {
            this.props.login();
        }
    };

    getNotifData = async () => {
        try {
            let notificationsData = await axios.get(APIURL + '/notifications', { params: { rec_id: this.props.user.emp_id, send_id: this.props.user.emp_id } })
            let numberNotifs = notificationsData.data.filter((notif) => !notif.isRead).length
            return numberNotifs
        } catch (err) {
            return 0
        }
    }

    componentDidMount = async () => {
        window.addEventListener('programs-updated', this.loadAssignedPrograms);
        let numberNotifRecorded = await this.getNotifData()
        this.setState({ numberNotifRecorded })

        try {
            let whatsNewUpdatesCount = await axios.get(APIURL + '/system/whatsnewcount', { params: {} })
            this.setState({ whatsNewVersionsCount: whatsNewUpdatesCount.data.NumberOfVersions })
        } catch (err) {
            console.error('Failed to load whats new count', err);
        }
        await this.loadAssignedPrograms();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user?.emp_id !== this.props.user?.emp_id || prevProps.user?.comp_id !== this.props.user?.comp_id) {
            this.loadAssignedPrograms();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('programs-updated', this.loadAssignedPrograms);
    }

    loadAssignedPrograms = async () => {
        if (!this.props.isAuth || !this.props.user?.emp_id || !this.props.user?.comp_id) {
            this.setState({ assignedPrograms: [] });
            return;
        }

        try {
            const [programsRes, assocRes] = await Promise.all([
                axios.get(`${APIURL}/programs`, { params: { company_id: this.props.user.comp_id } }),
                axios.get(`${APIURL}/programs/associations`, {
                    params: {
                        entity_type: 'employee',
                        entity_id: String(this.props.user.emp_id),
                        company_id: this.props.user.comp_id,
                        emp_id: this.props.user.emp_id,
                    },
                }),
            ]);

            const allPrograms = Array.isArray(programsRes.data) ? programsRes.data : [];
            const associations = Array.isArray(assocRes.data) ? assocRes.data : [];
            const assignedProgramIds = new Set(associations.map((a) => String(a.program_id)));

            const isAdmin = String(this.props.user?.type || '').toLowerCase() === 'admin';
            const assignedPrograms = isAdmin
                ? allPrograms
                : allPrograms.filter((p) => assignedProgramIds.has(String(p.program_id)));

            const selectedStillValid = assignedPrograms.some(
                (p) => String(p.program_id) === String(this.props.selectedProgramId)
            );
            if (this.props.selectedProgramId && !selectedStillValid && this.props.onProgramChange) {
                this.props.onProgramChange(null);
            }

            this.setState({ assignedPrograms });
        } catch (err) {
            console.error('Failed to load assigned programs', err);
            this.setState({ assignedPrograms: [] });
        }
    }

    onFocus = async () => {
        let numberNotifRecorded = await this.getNotifData()
        if (numberNotifRecorded - this.state.numberNotifRecorded > 0) {
            this.setState({ numberNotifRecorded: numberNotifRecorded, newNotificationAlert: true })
        } else {
            this.setState({ numberNotifRecorded: numberNotifRecorded, newNotificationAlert: false })
        }
    }

    handleSearchChange = (e, value, reason) => {
        if (reason === 'input') {
            this.setState({ searchQuery: value });
            if (this._searchDebounce) clearTimeout(this._searchDebounce);
            if (value.trim().length < 2) {
                this.setState({ searchResults: [], searchLoading: false });
                return;
            }
            this._searchDebounce = setTimeout(() => this.performSearch(value), 250);
        }
    };

    performSearch = async (query) => {
        const seq = ++this._searchSeq;
        this.setState({ searchLoading: true });
        try {
            const compId = this.props.user.comp_id;
            if (!this._dataCache || this._dataCacheCompId !== compId) {
                const [cusRes, projRes, conRes] = await Promise.all([
                    axios.get(APIURL + '/customers/v2', { params: { company_id: compId } }),
                    axios.get(APIURL + '/dropdowns/dropdownType/projectslist', { params: { comp_id: compId } }),
                    axios.get(APIURL + '/contacts', { params: { comp_id: compId } }),
                ]);
                this._dataCache = {
                    customers: cusRes.data || [],
                    projects: projRes.data || [],
                    contacts: Array.isArray(conRes.data) ? conRes.data : [],
                };
                this._dataCacheCompId = compId;
            }
            if (seq !== this._searchSeq) return;
            const now = new Date();
            const term = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
            const activeProjects = this._dataCache.projects.filter(
                p => p.start_date && p.end_date && new Date(p.end_date) >= now
            );
            // Clients and projects also match on DDD ID, shown next to the name when it is what matched.
            const dddMatch = (dddId) => (dddId != null && term.test(String(dddId)) ? String(dddId) : null);
            const customerResults = this._dataCache.customers
                .filter(c => term.test(c.cus_name) || dddMatch(c.DDDID))
                .slice(0, 5)
                .map(c => ({ ...c, _type: 'customer', _label: c.cus_name, _ddd: term.test(c.cus_name) ? null : dddMatch(c.DDDID), _group: 'Clients' }));
            const projectResults = activeProjects
                .filter(p => term.test(p.pname) || dddMatch(p.DDD_ID))
                .slice(0, 5)
                .map(p => ({ ...p, pro_id: p.pid, _type: 'project', _label: p.pname, _ddd: term.test(p.pname) ? null : dddMatch(p.DDD_ID), _group: 'Projects' }));
            const contactResults = this._dataCache.contacts
                .filter(c => term.test(c.contact_name || ''))
                .map(c => ({ ...c, con_id: c.id || c.con_id, _type: 'contact', _label: c.contact_name, _group: 'Contacts' }))
                .slice(0, 5);
            this.setState({ searchResults: [...customerResults, ...projectResults, ...contactResults], searchLoading: false });
        } catch (err) {
            console.error('Search error:', err);
            this._dataCache = null;
            if (seq === this._searchSeq) this.setState({ searchLoading: false });
        }
    };

    handleSearchResultClick = (type, item) => {
        this.setState({ searchQuery: '', searchResults: [] });
        if (type === 'customer') {
            this.props.history.push({
                pathname: '/customers',
                customersProps: { cus_id: item.cus_id, edit: false },
            });
        } else if (type === 'project') {
            this.props.history.push({
                pathname: '/projects',
                projectsProps: { pro_id: item.pro_id, cus_id: item.cus_id },
            });
        } else if (type === 'contact') {
            this.props.history.push({
                pathname: '/contacts',
                contactsProps: { con_id: item.con_id },
            });
        }
    };

    renderAuthMenuItem() {
        return (
            <>
            {this.props.isAuth && this.props.switchAccount && (
                <MenuItem onClick={() => {
                    this.handleCloseCompanyMenu();
                    this.props.switchAccount();
                }}>
                    <ListItemIcon><SwitchAccountIcon fontSize="small" /></ListItemIcon>
                    Switch account
                </MenuItem>
            )}
            <MenuItem onClick={this.handleMenuAuth}>
                <ListItemIcon>{this.props.isAuth ? <LogoutIcon fontSize="small" /> : <LoginIcon fontSize="small" />}</ListItemIcon>
                {this.props.isAuth ? 'Logout' : 'Login'}
            </MenuItem>
            </>
        );
    }

    render() {
        const open = Boolean(this.state.anchorEl);
        const id = open ? 'simple-popover' : undefined;
        const iconForType = { customer: 'fa-user', project: 'fa-folder', contact: 'fa-address-card' };
        const { user, isAuth } = this.props;
        const companyName = user.company_name ? user.company_name : 'Analytiq Inc';
        const hasNewNotifications = this.state.newNotificationAlert && !open;
        return (
            <header id="login-navbar">
                <AppBar
                    position='fixed'
                    color='inherit'
                    elevation={0}
                    onFocus={this.onFocus}
                    sx={{ zIndex: 2, backgroundColor: '#ffffff', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)' }}
                >
                    <Toolbar disableGutters sx={{ height: 70, minHeight: '70px !important', pl: 2, pr: `${TOOLBAR_RIGHT_PADDING}px`, gap: 2 }}>

                        {/* LEFT — Logo + Company + What's New */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0, minWidth: 0 }}>
                            <NavLink to="/" style={{ display: 'flex' }}>
                                <Box
                                    component="img"
                                    src={this.state.logoSrc}
                                    alt="logo"
                                    onError={() => this.setState({ logoSrc: DEFAULT_LOGO })}
                                    sx={{ height: 44, width: 44, objectFit: 'contain', borderRadius: '10px' }}
                                />
                            </NavLink>
                            <ButtonBase
                                onClick={this.handleOpenCompanyMenu}
                                aria-controls={this.state.anchorElCompany ? 'company-menu' : undefined}
                                aria-haspopup="true"
                                sx={{
                                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                                    px: 1, py: 0.5, borderRadius: '8px', minWidth: 0, textAlign: 'left',
                                    '&:hover': { backgroundColor: BRAND_LIGHT },
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                    <Typography noWrap sx={{ fontSize: 17, fontWeight: 600, color: TEXT, lineHeight: 1.3, maxWidth: 240 }}>
                                        {companyName}
                                    </Typography>
                                    <KeyboardArrowDownIcon sx={{ fontSize: 18, color: MUTED, ml: 0.25 }} />
                                </Box>
                                <Typography sx={{ fontSize: 11, color: MUTED, lineHeight: 1.2 }}>
                                    Powered by <span style={{ color: BRAND, fontWeight: 600 }}>FieldWorker</span>
                                    <Tooltip title={`Version ${VERSION} · Released ${VERSION_DATE}`}>
                                        <span style={{ marginLeft: 6 }}>· v{VERSION}</span>
                                    </Tooltip>
                                </Typography>
                            </ButtonBase>
                            <Menu
                                id="company-menu"
                                anchorEl={this.state.anchorElCompany}
                                open={Boolean(this.state.anchorElCompany)}
                                onClose={this.handleCloseCompanyMenu}
                                slotProps={{ paper: menuPaperProps }}
                            >
                                {isAuth && (
                                    <MenuItem onClick={() => this.handleMenuNavigate('/team-workload')}>
                                        <ListItemIcon><AssignmentIndOutlinedIcon fontSize="small" /></ListItemIcon>
                                        Team Workload
                                    </MenuItem>
                                )}
                                {isAuth && (
                                    <MenuItem onClick={() => this.handleMenuNavigate('/employees')}>
                                        <ListItemIcon><BadgeIcon fontSize="small" /></ListItemIcon>
                                        Employees
                                    </MenuItem>
                                )}
                                {isAuth && <Divider />}
                                {this.renderAuthMenuItem()}
                            </Menu>

                            <Tooltip title="What's New">
                                <IconButton onClick={this.handleOpenDialog} sx={actionIconSx} aria-label="What's New">
                                    <Badge badgeContent={this.state.whatsNewVersionsCount} color="primary" max={99}>
                                        <NewReleasesOutlinedIcon />
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                            <Dialog
                                open={this.state.isDialogOpen}
                                onClose={this.handleCloseDialog}
                                aria-labelledby="whats-new-dialog-title"
                                fullWidth
                                maxWidth="lg"
                                slotProps={{ paper: { sx: {
                                    borderRadius: 3, overflow: 'hidden',
                                    height: { xs: 'calc(100% - 32px)', sm: 'min(720px, calc(100% - 64px))' },
                                    width: { xs: 'calc(100% - 32px)', sm: 'calc(100% - 64px)' },
                                    m: { xs: 2, sm: 4 }
                                } } }}
                            >
                                <DialogTitle id="whats-new-dialog-title" sx={{ px: { xs: 3, sm: 4 }, py: 2.5, borderBottom: '1px solid #e5edf3' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pr: 4 }}>
                                        <Box sx={{ display: 'grid', placeItems: 'center', width: 42, height: 42, flexShrink: 0, bgcolor: BRAND_LIGHT, color: BRAND, borderRadius: 2 }}>
                                            <NewReleasesOutlinedIcon />
                                        </Box>
                                        <Box>
                                            <Typography component="span" sx={{ display: 'block', fontWeight: 700, fontSize: 20, color: TEXT }}>What's New in FieldWorker</Typography>
                                            <Typography component="span" variant="body2" color="text.secondary">The latest product updates and improvements</Typography>
                                        </Box>
                                    </Box>
                                    <IconButton aria-label="Close updates" onClick={this.handleCloseDialog} sx={{ position: 'absolute', right: { xs: 12, sm: 20 }, top: 20, color: 'text.secondary' }}>
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
                                    <WhatsNew />
                                </DialogContent>
                            </Dialog>
                        </Box>

                        {/* Global Search + Program filter — left-aligned after the company block */}
                        {isAuth && (
                            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1, minWidth: 0 }}>
                                <Autocomplete
                                    freeSolo
                                    clearOnEscape
                                    options={this.state.searchResults}
                                    groupBy={(opt) => opt._group}
                                    getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt._label)}
                                    inputValue={this.state.searchQuery}
                                    onInputChange={this.handleSearchChange}
                                    onChange={(e, opt) => {
                                        if (opt && typeof opt === 'object') {
                                            this.handleSearchResultClick(opt._type, opt);
                                        }
                                    }}
                                    loading={this.state.searchLoading}
                                    loadingText="Searching…"
                                    noOptionsText={this.state.searchQuery.trim().length < 2 ? 'Type at least 2 characters…' : 'No matches'}
                                    filterOptions={(x) => x}
                                    isOptionEqualToValue={(opt, val) => opt._type === val._type && opt._label === val._label}
                                    renderOption={(props, opt) => (
                                        <li {...props} key={`${opt._type}-${opt.cus_id ?? opt.pro_id ?? opt.con_id}`} style={{ fontSize: 14 }}>
                                            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 26, height: 26, borderRadius: '6px', backgroundColor: BRAND_LIGHT, mr: 1.25, flexShrink: 0 }}>
                                                <i className={`fas ${iconForType[opt._type]}`} style={{ color: BRAND, fontSize: 12 }} />
                                            </Box>
                                            {opt._label}
                                            {opt._ddd && (
                                                <Box component="span" sx={{ color: MUTED, fontSize: 12, ml: 1 }}>DDD {opt._ddd}</Box>
                                            )}
                                        </li>
                                    )}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                mt: 0.5,
                                                borderRadius: '10px',
                                                border: `1px solid ${BORDER}`,
                                                boxShadow: '0 8px 24px rgba(31, 45, 61, 0.12)',
                                                '& .MuiAutocomplete-groupLabel': { fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: MUTED, lineHeight: '32px' },
                                            },
                                        },
                                    }}
                                    sx={{ width: '100%', maxWidth: 300 }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Search clients, projects, contacts or DDD ID…"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <>
                                                        <SearchIcon sx={{ color: MUTED, mr: 0.5, fontSize: 20 }} />
                                                        {params.InputProps.startAdornment}
                                                    </>
                                                ),
                                                sx: pillInputSx,
                                            }}
                                        />
                                    )}
                                />
                                <TextField
                                    select
                                    size="small"
                                    value={this.props.selectedProgramId || ''}
                                    onChange={(e) => this.props.onProgramChange && this.props.onProgramChange(e.target.value || null)}
                                    sx={{
                                        width: 220,
                                        flexShrink: 0,
                                        display: { xs: 'none', md: 'inline-flex' },
                                        '& .MuiOutlinedInput-root': pillInputSx,
                                    }}
                                    SelectProps={{ displayEmpty: true, MenuProps: { slotProps: { paper: menuPaperProps } } }}
                                >
                                    <MenuItem value="">All Programs</MenuItem>
                                    {this.state.assignedPrograms.map((program) => (
                                        <MenuItem key={program.program_id} value={program.program_id}>
                                            {program.program_name || `Program #${program.program_id}`}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        )}

                        {/* RIGHT — Account + action icons */}
                        {isAuth && (
                            <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, ml: 'auto' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 0.5, py: 0.5 }}>
                                    <Avatar sx={{ width: 34, height: 34, fontSize: 14, fontWeight: 600, bgcolor: BRAND }}>
                                        {getInitials(user.emp_name)}
                                    </Avatar>
                                    <Box sx={{ display: { xs: 'none', lg: 'flex' }, flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 }}>
                                        <Typography noWrap sx={{ fontSize: 14, fontWeight: 600, color: TEXT, lineHeight: 1.2, maxWidth: 200 }}>{user.emp_name}</Typography>
                                        <Typography noWrap sx={{ fontSize: 12, color: MUTED, lineHeight: 1.2, maxWidth: 200 }}>{user.type}</Typography>
                                        <Typography noWrap title={user.email} sx={{ fontSize: 11, color: MUTED, lineHeight: 1.2, maxWidth: 200 }}>{user.email}</Typography>
                                    </Box>
                                </Box>

                                <Divider orientation="vertical" flexItem sx={{ mx: 1, my: 2, borderColor: BORDER }} />

                                <Tooltip title="Reports">
                                    <IconButton component={NavLink} to="/reports" sx={actionIconSx} aria-label="Reports">
                                        <TableChartOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Settings">
                                    <IconButton component={NavLink} to="/settings" sx={actionIconSx} aria-label="Settings">
                                        <SettingsOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Feature Requests">
                                    <IconButton component="a" href="https://fieldworker.canny.io/feature-requests" target="_blank" rel="noopener noreferrer" sx={actionIconSx} aria-label="Feature Requests">
                                        <LightbulbOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Help Center">
                                    <IconButton onClick={this.PopUpHelp} sx={actionIconSx} aria-label="Help Center">
                                        <HelpOutlineIcon />
                                    </IconButton>
                                </Tooltip>

                                {/* Empty slot — the Support button from App.js is rendered here */}
                                <Box sx={{ width: ICON_SIZE, flexShrink: 0 }} />

                                <Tooltip title="Notifications">
                                    <IconButton
                                        onClick={this.handleClick}
                                        aria-label="Notifications"
                                        sx={{
                                            ...actionIconSx,
                                            ...(open && { color: BRAND, backgroundColor: BRAND_LIGHT }),
                                            ...(hasNewNotifications && {
                                                color: BRAND,
                                                '@keyframes fwBellRing': {
                                                    '0%, 100%': { transform: 'rotate(0deg)' },
                                                    '20%': { transform: 'rotate(14deg)' },
                                                    '40%': { transform: 'rotate(-12deg)' },
                                                    '60%': { transform: 'rotate(8deg)' },
                                                    '80%': { transform: 'rotate(-4deg)' },
                                                },
                                                '& svg': { animation: 'fwBellRing 1s ease-in-out 3', transformOrigin: 'top center' },
                                            }),
                                        }}
                                    >
                                        <Badge
                                            badgeContent={this.state.numberNotifRecorded}
                                            max={99}
                                            sx={{ '& .MuiBadge-badge': { backgroundColor: '#FA7171', color: '#ffffff', fontSize: 10, fontWeight: 600 } }}
                                        >
                                            {hasNewNotifications ? <NotificationsActiveIcon /> : <NotificationsNoneOutlinedIcon />}
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={this.state.anchorEl || null}
                                    onClose={this.handleClose}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    slotProps={{ paper: { sx: { mt: 1, maxHeight: 'calc(100vh - 88px)', borderRadius: '10px', border: `1px solid ${BORDER}`, boxShadow: '0 8px 24px rgba(31, 45, 61, 0.12)' } } }}
                                >
                                    <Notifications user={user} />
                                </Popover>
                            </Box>
                        )}

                    </Toolbar>
                </AppBar>
            </header>
        );
    }

}

export default withRouter(NavBar);
